<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="850px"
    :title="titleName + '内容表单'"
    :visible.sync="dialogFormVisible"
     :close-on-click-modal="false"
  >
    <el-form :model="form" ref="form" >
      <h3 class="title" v-if="titleName == '编辑'">提示: 如需修改问答，请在输入完成问答项后点击修改提交</h3>
      <el-form-item label="当前菜单状态" :label-width="formLabelWidth" prop="status" >
        <el-select class="search-select" v-model="form.status" placeholder="请选择状态"  :rules="{ required: true, message: '状态不能为空', trigger: ['blur', 'change'] }" >
           <el-option  v-for="(item, index) in rolesList" :key="index" :label="item.label" :value="item.value" ></el-option>
        </el-select>
        <el-button size="small" icon="el-icon-plus" @click="addFormItem" type="primary" class="addBtn" v-if="titleName == '新增'">新增</el-button>
      </el-form-item>
      <el-divider></el-divider>
      <template>
        <div v-for="(item, index ) in form.helpContent" :key="index" name="helpContent">
            <el-form-item label="问答状态" :label-width="formLabelWidth" prop="status" >
              <el-select class="search-select" v-model="item.status" placeholder="请选择状态">
                <el-option  v-for="(item, index) in rolesList" :key="index" :label="item.label" :value="item.value" :rules="{ required: true, message: '状态不能为空', trigger: ['blur', 'change'] }" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="'问题'+ (index+1)" :label-width="formLabelWidth" :prop="'helpContent.' + index + '.question'" :rules="{ required: true, message: '问题不能为空', trigger: ['blur', 'change'] }">
              <el-input    v-model="item.question" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item :label="'答案'+ (index+1)" :label-width="formLabelWidth" :prop="'helpContent.' + index + '.answer'" :rules="{ required: true, message: '答案不能为空', trigger: ['blur', 'change'] }">
              <el-input v-model="item.answer" autocomplete="off"   type="textarea"  autosize></el-input>
            </el-form-item>
            <div class="btn">
              <el-button size="small" icon="el-icon-edit" @click="editFormItem(index)" type="info" v-if="titleName == '编辑'">修改</el-button>
              <el-button size="small" icon="el-icon-delete" @click="delFormItem(index)" type="danger" >删除</el-button>
            </div>
            <el-divider></el-divider>
        </div>
      </template>
      

      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false" >取 消</el-button>
      <el-button type="success" @click="submitBtn">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {  setHelpContentApi, addHelpContentApi, delHelpContentApi, getHelpContentApi } from '@/api/newsApi.js'
export default {
  name: 'contentForm',
  data () {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      form: {
        status: '',
        helpId: '',
        helpContent: [
          { question: '',  answer: '答:', status:''}
        ],
      },
      titleName: '新增',
      rolesList: [
        {label: '编辑中', value: 1},
        {label: '已发布', value: 2},
        {label: '已删除', value: 3}
      ],
    }
  },
  methods: {

    // 保存
    submitBtn () {
      try {
        // 如果是编辑就关闭对话框， 不是就发送新增请求
        if(this.titleName !== '新增') return  this.dialogFormVisible = false
        this.$refs.form.validate(async valid => {
          window.console.log(valid)
          if(!valid) return
          await addHelpContentApi({...this.form}).then(res => {
            if(res.code !== 200) return 
            this.$message.success(this.titleName + '成功!')
            this.dialogFormVisible = false
            this.form = {
              status: '',
              helpId: '',
              helpContent: [ { question: '',  answer: '答:', status:''} ],
            }
            // 重新请求数据
            this.$emit('fetchData')
          })
        })
      } catch (e) {
        window.console.log(e)
      }
    },

    // 新增表单项
    addFormItem() {
      this.form.helpContent.push( { question: '',  answer: '答: ', status: ''} )
    },

    // 编辑表单项
    async editFormItem(index) {
      try {
        let { contentId, question, answer, status } = this.form.helpContent[index]
        let data = 'contentId=' + contentId + '&question=' + question + '&answer=' + answer + '&status=' + status
        await setHelpContentApi(data).then(res => {
          if(res.code !== 200) return 
          this.$message.success('修改成功！')
          this.getContentData()
        })
      } catch(e) {
        window.console.log(e)
      }
    },

        // 编辑内容
    async getContentData() {
      try {
        // 获取内容
        await getHelpContentApi(this.form.helpId).then(res => {
          if(res.code !== 200) return 
          // 设置内容
          let newList = res.data.map(item => {
            return { 
              answer: item.answer,
              question: item.question,
              contentId: item.contentId,
              status: item.status
            }
          })
          this.form.helpContent = newList
        })
      } catch (e) {
        window.console.log(e)
      }
    },

    // 删除表单项
    delFormItem(index) {
      this.titleName === '新增' ? this.form.helpContent.splice(index, 1) : this.delRuq(index)
      
    },


    // 删除请求
    async delRuq(index) {
      try {
        await delHelpContentApi(this.form.helpContent[index].contentId).then(res => {
          if(res.code !== 200) return this.$message.success('删除成功!')
          this.form.helpContent.splice(index, 1)
        })
      } catch (e) {
        window.console.log(e)
      }
    }


  }
}
</script>

<style lang="less" scoped>
  .title {
    margin: 0 0 20px 20px;
  }
  .addBtn {
    margin-left: 300px;
  }


  .btn {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
  }
</style>
